module.exports = __webpack_public_path__ + "static/21-analytics-box-79d1724ee959c207e954e381e6feface.png";